import {
    DraftState,
    Template,
    TemplateType
} from "../../../core/entities/template";
import { TemplateDto } from "../templateDto";

export function mapDtoToTemplate(
    templateDto: TemplateDto,
    index?: number
): Template {
    return {
        id: templateDto.id,
        title: SetTitle(templateDto) + (index ? ` (${index})` : ""),
        author: templateDto.author,
        content: templateDto.content,
        type: templateDto.type,
        createdAt: new Date(templateDto.createdAt),
        draftState: templateDto.draftState,
        framedContent: templateDto.framedContent
    };
}

function SetTitle(tmp: TemplateDto) {
    let state = "";
    switch (tmp.draftState) {
        case DraftState.Draft:
            state = "Kladde af Kvittering";
            break;
        case DraftState.Published:
        case DraftState.Historic:
            state = "Kvittering";
            break;
    }
    let type = "";
    switch (tmp.type) {
        case TemplateType.DelA:
            type = "A";
            break;
        case TemplateType.DelB:
            type = "B";
            break;
    }
    return `${state} ${type}`;
}
